import { RodRequestCaddy } from '@bechtel/types';

export interface CaddyListProps {
  caddies: RodRequestCaddy[];
  canEditCaddy?: boolean;
  onEditCaddy?: (caddy: RodRequestCaddy) => void;
  onDeleteCaddy: (caddy: RodRequestCaddy) => void;
}
